import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "popup-container inner"
}
const _hoisted_2 = { class: "popup-card" }
const _hoisted_3 = { class: "popup-image" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "media/logos/banner.jpg",
  alt: "Womens Day Image"
}, null, -1)
const _hoisted_5 = {
  for: "popup-checkbox",
  class: "popup-checkbox-label"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "checkbox-icon" }, null, -1)
const _hoisted_7 = {
  id: "kt_header",
  style: {},
  class: "header align-items-stretch"
}
const _hoisted_8 = {
  class: "d-flex align-items-center d-lg-none ms-n3 me-1",
  title: "Show aside menu"
}
const _hoisted_9 = {
  class: "btn btn-icon btn-active-light-primary",
  id: "kt_aside_mobile_toggle"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2x mt-1" }
const _hoisted_11 = {
  class: "d-flex align-items-center d-lg-none ms-n3 me-1",
  title: "Show main menu"
}
const _hoisted_12 = {
  class: "btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px",
  id: "kt_header_menu_mobile_toggle"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center flex-grow-1 flex-lg-grow-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "d-lg-none"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "Logo",
      src: "media/logos/sicip.png",
      class: "h-30px"
    })
  ])
], -1)
const _hoisted_14 = { class: "d-flex align-items-stretch justify-content-between flex-lg-grow-1" }
const _hoisted_15 = {
  class: "d-flex align-items-stretch",
  id: "kt_header_menu_nav"
}
const _hoisted_16 = { class: "d-flex align-items-stretch flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_KTMenu = _resolveComponent("KTMenu")!
  const _component_KTTopbarButton = _resolveComponent("KTTopbarButton")!
  const _component_KTTopbar = _resolveComponent("KTTopbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      duration: "550",
      name: "nested"
    }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    class: "popup-close",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = !_ctx.show))
                  }, "X"),
                  _hoisted_4,
                  _createElementVNode("label", _hoisted_5, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "popup-checkbox",
                      class: "popup-checkbox",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
                    }),
                    _hoisted_6,
                    _createTextVNode(" Don't show again ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass([{
        'container-fluid': _ctx.headerWidthFluid,
        'container-xxl': !_ctx.headerWidthFluid,
      }, "d-flex align-items-stretch justify-content-between"])
      }, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs015.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/text/txt003.svg" })
          ])
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_KTMenu)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_KTTopbarButton),
            _createVNode(_component_KTTopbar)
          ])
        ])
      ], 2)
    ])
  ], 64))
}